import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { MarketingHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/MarketingHubFaqs';
import { MarketingHubProductIcon } from 'pricing-pages-ui-components/productIcon/MarketingProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import CalculatorAnchorLink from '../../components/CalculatorAnchorLink';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import PhoneSupportMiddle from '../../components/phone-support/PhoneSupportMiddle';
import { SCREENS } from '../../constants/tracking/Screens';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { MarketingHubFeatureTable } from './MarketingHubFeatureTable';
import { MarketingHubMerchCards } from './MarketingHubMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MARKETING_HUB_API_NAMES = [Products.MARKETING_HUB_STARTER, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE];
export const MarketingHubPage = () => {
  const screen = SCREENS.MARKETING;
  useDocumentTitle(screen);
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "MARKETING_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "MARKETING",
      apiNames: MARKETING_HUB_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(MarketingHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.marketing.pageTitle"
        })]
      }), /*#__PURE__*/_jsxs(PageSubTitle, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.marketing.description"
        }), /*#__PURE__*/_jsx(CalculatorAnchorLink, {
          defaultProductApiName: Products.MARKETING_HUB_PROFESSIONAL
        })]
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(MarketingHubMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "marketing"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(MarketingHubFeatureTable, {})
    }), /*#__PURE__*/_jsx(PhoneSupportMiddle, {
      phoneSourceId: "marketing-middle",
      screen: screen,
      apiName: Products.MARKETING_HUB_STARTER
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "marketing"
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(MarketingHubFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "marketing-footer",
      screen: screen,
      apiName: Products.MARKETING_HUB_STARTER
    })]
  });
};